/**
 * A guest closing a wallet sheet without paying.
 *
 * Not a failure, and worth its own type because the two wallets report it completely differently — Google
 * rejects with a `statusCode` of `CANCELED`, Apple fires an `oncancel` handler and never rejects at all.
 * Normalising both here means the component that obeys an action has one thing to check rather than a branch
 * per vendor, which is the same reason the server sends actions instead of processor names.
 */
export class WalletCancelledError extends Error {
    constructor() {
        super('The guest dismissed the wallet sheet.');
        this.name = 'WalletCancelledError';
    }
}

export function isWalletCancelled(error: unknown): boolean {
    return error instanceof WalletCancelledError;
}
